import React, { Component } from "react";

import { Link } from "react-router-dom";
import { withTranslation } from 'react-i18next';

import SubAsset from "./subasset";
import BuyModal from "./buy-modal";

//import PreviousList from "./previous-list";
//import AssetControls from "./AssetControls"

import "./asset.css";

import Loading from "../../components/Loading";
import RegTimer from "../../components/RegTimer";

import ShowValue from "../../components/ShowValue";
//import MessageModal from "../../components/Message";

import ApiBuy from "../../utils/api.buy";

import AuthService from "../../utils/auth.service";

declare var location;
declare var FB;

const LEVEL_TRANSFORM = ["all/childs", "childs", "childs", "childs", "childs"];

class AssetPage extends Component {

  authService = AuthService;

  constructor(props) {
    super(props);

    let current = props.asset.key;
    let company_code = localStorage.getItem('company_code');

    let query = {};
    if (location.search) {
      let queryStr = location.search;

      if (location.search.includes(current)) {
        let queryA = location.search;
        queryA.substr(1, queryA.length - 1).split("&").forEach(str => {
          let parse = str.split("=");
          query[parse[0]] = parse[1];
        });
        const queryArr = query.assetline.split(",");
        queryArr.pop();
        queryArr.push(current);
        query.assetline = queryArr.join(",");
      } else {
        queryStr.substr(1, queryStr.length - 1).split("&").forEach(str => {
          let parse = str.split("=");
          query[parse[0]] = parse[1];
        });
        const queryArr = query.assetline.split(",");
        queryArr.pop();
        queryArr.push(current);
        query.assetline = queryArr.join(",");
      }
    }

    this.state = {

      current: { previous_owners: [{}], balances: {} },

      transaction: { transaction: [] },

      childs: [],

      st_company_code: company_code,
      assetline: query.assetline,

      winners_loading: false,
      modal: { title: "Auction Status", message: "", isOpen: false },

      profile: AuthService.profileUser,

      //value: 0.0,
      //buying: false,

      asset: this.props.asset,

      //auction_cron: "Cron",

      leaveMessageModal: { isOpen: false },
      isOpen: false,
      loading: false

    };

    this.loadFullAsset = this.loadFullAsset.bind(this);
    this.toggle = this.toggle.bind(this);
    this.buyAsset = this.buyAsset.bind(this);
    this.shareFB = this.shareFB.bind(this);
    //this.backPage = this.backPage.bind(this);
    //this.toggleAuction = this.toggleAuction.bind(this);
    //this.handleAuctionSubmit = this.handleAuctionSubmit.bind(this);
    //this.handleInput = this.handleInput.bind(this);
    this.changeModalStatus = this.changeModalStatus.bind(this);
    this.toggleLeaveMessageModal = this.toggleLeaveMessageModal.bind(this);
    this.toggleMessageModal = this.toggleMessageModal.bind(this);
    this.changeAssetLine = this.changeAssetLine.bind(this);
    this.assetIsInAuction = this.assetIsInAuction.bind(this)
  }

  componentDidMount() {
  	//this.loadFullAsset(this.state.asset)
  }

  componentWillMount() {
  	//console.log('Asset Page will Mount...');
	  if (this.state.asset) {
		  this.setState(...this.state, {loading: true, asset: this.props.asset});
		  this.loadFullAsset(this.state.asset);
	  }
  }

  componentWillReceiveProps(props) {
  	//console.log('Asset Page will receive Props...');
    if (props) {
      this.setState(...this.state, { loading: true, asset: props.asset });
      this.loadFullAsset(props.asset);
    }
  }

  updateProfile(profile) {
    this.setState(...this.state, { profile: AuthService.profileUser });
  }

  buyAsset() {
    this.setState(...this.state, { profile: AuthService.profileUser, loading: true });
    
    if (this.assetIsInAuction()) {
	
	    new ApiBuy().buy(this.state.st_company_code, this.state.assetline).then(response => {
		    if (response.data) {
			    response.data.transaction = response.data.transaction ? response.data.transaction : [];
			
			    this.setState(...this.state, {isOpen: true, transaction: response.data, loading: false});
		    }
	    });
    } else {
    	this.setState(...this.state, { loading: false});
    }
  };

  changeModalStatus(title, message) {
    this.setState(...this.state, {
      modal: { title: title, message: message, isOpen: true }
    });
  }

  toggleMessageModal() {
    this.setState(...this.state, { modal: { isOpen: false } });
  }
	
  toggleLeaveMessageModal() {
    this.setState({
      leaveMessageModal: { isOpen: !this.state.leaveMessageModal.isOpen }
    });
  }

  toggle() {
    this.setState(...this.state, { isOpen: !this.state.isOpen });
  };

	
  shareFB() {
    FB.ui(
      {
        method: "share",
        display: "popup",
        quote: `Ola, Acabo de comprar um "Winvite" no site Winvite.io!!`,
        href: location.href
      },
      function (response) { }
    );
  };

  changeAssetLine(assetline) {
  	console.log('Change asset line calling loadCurrentAsset...')
    this.props.loadCurrentAsset(assetline);
  };

  backPage() {
    let queryStr = location.search, query = {};

    queryStr.substr(1, queryStr.length - 1).split("&").forEach(str => {
      let parse = str.split("=");
      query[parse[0]] = parse[1];
    });

    let assetline = this.state.assetline.split(",");
    assetline.pop();

    let goTo = assetline.join(","), url = "";

    /*TODO: sun = "2" = winvite */


    if (goTo === "2" || goTo === "3") {
      url = "/"; /* planets */
    } else {
      url = "/assets/?assetline=" + goTo;
    }
	  
    return url;
  };

  loadFullAsset(asset) {
    let childs = [];

    if (asset.info.level < 6) {
      let child = asset[LEVEL_TRANSFORM[asset.info.level]];
      if (child) {
        childs = Object.keys(child).map(key => {
          let tChild = child[key];
          tChild["key"] = key;

          if (tChild.info.level === 5) {
              tChild.info.image = "/assets/images/mark.png";
          }

          tChild["assetline"] = `/assets/?assetline=${this.state.assetline},${key}`;

          if (tChild.info.position) {
            let borderRadius = tChild.info.level === 5 ? 0 : 0;

            tChild["style"] = {
              left: tChild.info.position.x - 15,
              top: tChild.info.position.y - 170,
              borderRadius: borderRadius,
              width: tChild.info.size.width,
              height: tChild.info.size.height
            };
          }

          return tChild;
        });
      }
    }

    asset.info.level_name =
        asset.level_name = LEVEL_TRANSFORM[asset.info.level - 1].charAt(0).toUpperCase() +
        LEVEL_TRANSFORM[asset.info.level - 1].slice(1).replace("s", "");

    this.setState(...this.state, {
      current: asset.info,
      childs: childs,
      loading: false,
      winners_loading: true
    })
  };
  
  assetIsInAuction() {
	  
  	const starts= this.state.asset.info.asset_timing ? this.state.asset.info.asset_timing.auction_starts : "";
  	const ends= this.state.asset.info.asset_timing ? this.state.asset.info.asset_timing.auction_ends : "";
  	
  	const new_ends = ends.replace('Z','Z');
  	const new_starts = starts.replace('Z','Z');

	  const date_starts = new Date(new_starts).getTime();
	  const date_ends = new Date(new_ends).getTime();
	  
	  //const now = new Date().getTime();
	  const now = new Date();
    const now_gmt = now.getTime(); // + (now.getTimezoneOffset() * 60000);
    
	  
	  return (now_gmt >= date_starts && now_gmt <= date_ends);
  	
  };
	
  render() {
  	
  	const { t } = this.props;

    return (
      <section>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="pt-5 mt-5" hidden={this.state.loading}>

                <h1 className="asset-title" >
                  {this.state.asset.info.name === this.state.asset.info.level_name ? "" : this.state.asset.info.name}
                </h1>{" "}
                {/* Asset Name*/}

	              {/*<h4 className="auction-description" hidden={!this.state.asset.info.asset_timing}>
                    Event date :
                    {this.state.asset.info.asset_timing ? this.state.asset.info.asset_timing.event_date : ""}
                </h4>*/}


                <p className="text-right asset-description"
                  hidden={(!this.state.profile) || (this.state.profile.uid !== this.state.asset.info.previous_owners[0].previous_owner_uid)}>
	                {/*Este Winvite pertence a vc. Conte para os seus amigos!!!*/}
	                {t('asset.belong')}
                </p>

                  {/* <hr /><hr hidden={!this.state.asset.info.owner_message} /> */}
                  
                <div>
	                <hr />
	
	                <Link hidden={this.state.asset.info.level ? (this.state.asset.info.level < 3) : false }
	                      className="btn btn-outline-secondary"
	                        to={this.backPage()}>
	                  <i className="fas fa-caret-left" />
		                {t('common.back')}
	                </Link>{" "}
	                {/* Back Button */}
	
	                {/*<button*/}
	                  {/*className="btn btn-outline-primary float-right"*/}
	                  {/*hidden={(!this.state.profile) || (this.state.profile.uid !== this.state.asset.info.previous_owners[0].previous_owner_uid)}>*/}
	                  {/**/}
	                  {/*<i className="fab fa-facebook-f" />*/}
	                  {/**/}
	                  {/*Share*/}
	                {/*</button>{" "}*/}
	                {/* Share Button */}
	
	                <a href={`mailto:myfriends@gmail.com?subject=Olá. Comprei um Winvite hoje...,
	                       &body=Hello amigos,
	                        Acabo de adquirir um Winvite. Vc sabe o que é isto?
	                        Veja em winvite.io
	                        Divirta-se...
	                        %0D`}
	                  className="btn btn-outline-info float-right"
	                  hidden={(!this.state.profile) || (this.state.profile.uid !== this.state.asset.info.previous_owners[0].previous_owner_uid)}>
	                  <i className="fa fa-envelope" />
	                  Email
	                </a>{" "}
	                {/* Message Button */}
	
	                <button
	                  className="btn btn-outline-success float-right"
	                  onClick={this.buyAsset}
	                  hidden={(!this.state.asset.info.on_sale) || (!this.assetIsInAuction())
	                    || (this.state.profile ? this.state.asset.info.previous_owners ?
		                  (this.state.profile.uid === this.state.asset.info.previous_owners[0].previous_owner_uid) : true : true)
	                  }>
		                {t('common.buy')}<ShowValue btc={this.state.asset.info.previous_owners[0].previous_owner_asset_price} />
	
	                </button>{" "}
	                
	                <button
	                  className="btn btn-outline-danger float-right"
	                  hidden={(!this.state.asset.info.on_sale) || (this.assetIsInAuction())
	                    || (this.state.profile ? this.state.asset.info.previous_owners ?
		                  (this.state.profile.uid === this.state.asset.info.previous_owners[0].previous_owner_uid) : false : false)
	                  }>
	                  <ShowValue btc={this.state.asset.info.previous_owners[0].previous_owner_asset_price} />
	
	                </button>{" "}
	                {/* Buy Now Button */}
	
	                <hr/>
	                
                </div>

	              {/*<AssetControls
                    backto={() => this.backPage}
                    buy={() => this.buyAsset()}
                    hidden={!this.state.asset.info.on_sale || this.state.profile.uid === this.state.asset.info.previous_owners[0].previous_owner_uid}
                    price={this.state.asset.info.previous_owners[0].previous_owner_asset_price}
                    notmine={this.state.profile.uid !== this.state.asset.info.previous_owners[0].previous_owner_uid}
                    inauction={this.assetIsInAuction()}
                />*/}


                <h5 className="auction-timing float-lg-none" hidden={!this.state.asset.info.asset_timing}>
                    <RegTimer
                        starts={this.state.asset.info.asset_timing ? this.state.asset.info.asset_timing.auction_starts : ""}
                        ends={this.state.asset.info.asset_timing ? this.state.asset.info.asset_timing.auction_ends : ""}
                    />

                </h5>

                <div className="asset-view">

                  {/* Main image */}

                  <div hidden={this.state.asset.info.video || this.state.asset.info.hideMainImg}>
                    <img src={this.state.asset.info.image} alt=""
                         width={this.state.asset.info.image_position ? this.state.asset.info.image_position.width : 250}
                         height={this.state.asset.info.image_position ? this.state.asset.info.image_position.height : 250} />
                  </div>

                  {/* Sub Assets */}

                  {this.state.childs.map(child => (<SubAsset key={child.key} child={child} />))}

                </div>{" "}

                {/* Image and Sub Assets */}


                {/* Price */}
                {/* onClick={() => { this.getClick('asset-price') }} */}
                  <h3 className="asset-price" hidden={!this.state.asset.info.on_sale} >
                  <ShowValue btc={this.state.asset.info.previous_owners[0].previous_owner_asset_price} />
                </h3>{" "}
                {/* Price */}
                
                <div hidden={this.state.assetline !== '2,2_4,2_4_5'}>
		              <br/><br/><hr/>
                </div>
	              

                <p className="asset-description" >
                    {this.state.asset.info.description}
                </p>
	              
	              <div>
		              <div className="row">
			              <div className={!this.state.asset.info.asset_description
			                              || !this.state.asset.info.asset_description.desc1 ? "col-md-12":"col-md-8"}>
				              <p className="asset-description" >
			                    {this.state.asset.info.asset_description ?
				                    this.state.asset.info.asset_description.desc1 ?
					                    this.state.asset.info.asset_description.desc1.description : "" : ""}
			                </p>
			              </div>
			             
										<div className="col-md-4"
										     hidden={!this.state.asset.info.asset_description
																|| !this.state.asset.info.asset_description.desc1
										            || !this.state.asset.info.asset_description.desc1.img}>
											
				              <div className="align-content-center" >
			                    <img src={this.state.asset.info.asset_description ?
				                    this.state.asset.info.asset_description.desc1 ?
					                    this.state.asset.info.asset_description.desc1.img ?
						                    this.state.asset.info.asset_description.desc1.img.image : "" : "" : "" }
			                         alt=""
			                         width={this.state.asset.info.asset_description ?
				                         this.state.asset.info.asset_description.desc1 ?
					                         this.state.asset.info.asset_description.desc1.img ?
						                         this.state.asset.info.asset_description.desc1.img.width ?
							                         this.state.asset.info.asset_description.desc1.img.width : 100 : 100 : 100 : 100 }
			                         
			                         height={this.state.asset.info.asset_description ?
				                         this.state.asset.info.asset_description.desc1 ?
				                          this.state.asset.info.asset_description.desc1.img ?
					                         this.state.asset.info.asset_description.desc1.img.height ?
						                         this.state.asset.info.asset_description.desc1.img.height : 100 : 100 : 100 : 100 } />
				              </div>
										</div>
		              </div>
	              </div> {/* desc1 */}
	              
	              <div>
		              <div className="row">
			              <div className={!this.state.asset.info.asset_description
			                              || !this.state.asset.info.asset_description.desc2 ? "col-md-12":"col-md-8"}>
				              <p className="asset-description" >
			                    {this.state.asset.info.asset_description ?
				                    this.state.asset.info.asset_description.desc2 ?
					                    this.state.asset.info.asset_description.desc2.description : "" : ""}
			                </p>
			              </div>
			             
										<div className="col-md-4"
										     hidden={!this.state.asset.info.asset_description
																|| !this.state.asset.info.asset_description.desc2
										            || !this.state.asset.info.asset_description.desc2.img}>
											
				              <div className="align-content-center" >
			                    <img src={this.state.asset.info.asset_description ?
				                    this.state.asset.info.asset_description.desc2 ?
					                    this.state.asset.info.asset_description.desc2.img ?
						                    this.state.asset.info.asset_description.desc2.img.image : "" : "" : "" }
			                         alt=""
			                         width={this.state.asset.info.asset_description ?
				                         this.state.asset.info.asset_description.desc2 ?
					                         this.state.asset.info.asset_description.desc2.img ?
						                         this.state.asset.info.asset_description.desc2.img.width : 100 : 100 : 100 }
			                         
			                         height={this.state.asset.info.asset_description ?
				                         this.state.asset.info.asset_description.desc2 ?
				                          this.state.asset.info.asset_description.desc2.img ?
					                          this.state.asset.info.asset_description.desc2.img.height ?
					                            this.state.asset.info.asset_description.desc2.img.height : 100 : 100 : 100 : 100} />
				              </div>
										</div>
		              </div>
	              </div> {/* desc2 */}
	              
	              <div>
		              <div className="row">
			              <div className={!this.state.asset.info.asset_description
			                              || !this.state.asset.info.asset_description.desc3 ? "col-md-12":"col-md-8"}>
				              <p className="asset-description" >
			                    {this.state.asset.info.asset_description ?
				                    this.state.asset.info.asset_description.desc3 ?
					                    this.state.asset.info.asset_description.desc3.description : "" : ""}
			                </p>
			              </div>
			             
										<div className="col-md-4"
										     hidden={!this.state.asset.info.asset_description
																|| !this.state.asset.info.asset_description.desc3
										            || !this.state.asset.info.asset_description.desc3.img}>
											
				              <div className="align-content-center" >
			                    <img src={this.state.asset.info.asset_description ?
				                    this.state.asset.info.asset_description.desc3 ?
					                    this.state.asset.info.asset_description.desc3.img ?
						                    this.state.asset.info.asset_description.desc3.img.image : "" : "" : "" }
			                         alt=""
			                         width={this.state.asset.info.asset_description ?
				                         this.state.asset.info.asset_description.desc3 ?
					                         this.state.asset.info.asset_description.desc3.img ?
						                         this.state.asset.info.asset_description.desc3.img.width ?
							                         this.state.asset.info.asset_description.desc3.img.width : 100 : 100 : 100 : 100 }
			                         
			                         height={this.state.asset.info.asset_description ?
				                         this.state.asset.info.asset_description.desc3 ?
				                          this.state.asset.info.asset_description.desc3.img ?
					                         this.state.asset.info.asset_description.desc3.img.height ?
						                         this.state.asset.info.asset_description.desc3.img.height : 100: 100 : 100 : 100 } />
				              </div>
										</div>
		              </div>
	              </div> {/* desc3 */}
	              

	              {/*<AssetControls
                    backto={this.backPage}
                    buy={this.buyAsset}
                    hidden={!this.state.asset.info.on_sale || this.state.profile.uid === this.state.asset.info.previous_owners[0].previous_owner_uid}
                    price={this.state.asset.info.previous_owners[0].previous_owner_asset_price}
                    notmine={this.state.profile.uid !== this.state.asset.info.previous_owners[0].previous_owner_uid}
                    inauction={this.assetIsInAuction}
                />*/}
	              

                <a target="_blank" className="float-right" hidden={!this.state.asset.info.wiki} href={this.state.asset.info.wiki}>
	                {t('common.about')} {this.state.asset.info.name}{" "}
                  <i className="fas fa-external-link-alt pb-1" />
                </a>{" "}
                {/* About Asset */}
                <br />


              </div>
            </div>{" "}
            {/* Classet */}

	          {/*<div className="col-md-4" hidden={!this.state.asset.info.on_sale}>
              <PreviousList assetline={this.state.assetline ? this.state.assetline : ""} classetLanders={this.state.asset.info.previous_owners} />
            </div>{" "}*/}

          </div>
        </div> {/* Asset Show */}

        <BuyModal
          current={this.state.asset.info}
          transaction={this.state.transaction}
          buyAsset={this.buyAsset}
          isOpen={this.state.isOpen}
          changeAssetLine={this.changeAssetLine}
          toggle={this.toggle}
        />

        <Loading active={this.state.loading} />
      </section >
    );
  }
}

export default withTranslation()(AssetPage);



// WEBPACK FOOTER //
// ./src/containers/AssetPage/index.js